import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TradeAssetState } from './position-details.state';
import { tradeAssetFeatureKey } from './position-details.reducers';

export const selectPositionDetail = createFeatureSelector<TradeAssetState>(tradeAssetFeatureKey);

export const selectTradeAsset = createSelector(selectPositionDetail, (state: TradeAssetState) => state);